import Vue from "vue";
import VueRouter from "vue-router";

//屏蔽路由报错信息
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path:'/login',
    component: () => import("@/views/login"),
    invisible: false
  },
  {
    path: "/certification",
    component: () => import("@/views/Certification"),
  },
  {
    path: "/salary",
    component: () => import("@/views/Salary"),
  },
  {
      path:'/person',
      component: () => import("@/views/person")
  },
  {
      path:'/service',
      component: () => import("@/views/service")
  },
  {
      path:'/complaint',
      component: () => import('@/views/complaint')
  },
  {
      path:'/reward',
      component: () => import('@/views/reward')
  }
];

const router = new VueRouter({
    // mode: 'history',
    routes,
});

export default router;
